import { type OpenShiftListItem } from "@src/appV2/redesign/Shift/Open/types";

export function getShiftStart(shift: OpenShiftListItem): string | undefined {
  if (shift.type === "open-shift") {
    return shift.attributes?.start;
  }

  return shift.start;
}

export function getShiftId(shift: OpenShiftListItem): string {
  if (shift.type === "open-shift") {
    return shift.id;
  }

  if (shift.type === "in-app-ad") {
    return shift.appId;
  }

  if (shift.type === "fortune-cookie") {
    return "fortune-cookie";
  }

  if (shift.type === "worker-pay-survey") {
    return shift.surveyId;
  }

  return "unknown";
}

export function createShiftSignature(shifts: OpenShiftListItem[]): string {
  return JSON.stringify(
    shifts.map((shift) => ({
      type: shift.type,
      id: getShiftId(shift),
      start: getShiftStart(shift),
    }))
  );
}
